import { ExclamationCircleOutlined } from '@ant-design/icons';
import { styled } from 'styled-components';

export const WarningIcon = styled(ExclamationCircleOutlined)`
  color: #faad14;
  font-size: 20px;
`;
